import { config } from '@/config';
import { getLang } from '@/locale';
import type { Catalogue, Globals } from '@bokadirekt/tracking-schema/marketplace';
import { SCHEMA_VERSION } from '@bokadirekt/tracking-schema/marketplace';
import { amplitudeLogEvent } from './analytics';
import { allowTracking } from './general';

const ENVIRONMENT: Record<string, Globals['environment']> = {
  prod: 'production',
  stage: 'staging',
  smoke: 'staging',
};

/**
 * The tracking layer for events in the tracking schema's Catalogue: the event name picks
 * its payload, and the globals every event carries are stamped here, never by a call site.
 */
// ponytail: a union-typed `event` lets one event's payload pass for another; call sites pass literals
export function track<K extends keyof Catalogue>(event: K, properties: Catalogue[K]) {
  if (!allowTracking()) return;

  const globals: Globals = {
    product: 'marketplace',
    environment: ENVIRONMENT[config.envName] ?? 'development',
    actor_type: navigator.webdriver ? 'automation' : 'human',
    schema_version: SCHEMA_VERSION,
    locale: getLang(),
  };

  amplitudeLogEvent(event, { ...properties, ...globals });
}
